import SpiderBulkCreate from '@/pages/spiders/bulk-create.vue'
import SpiderCreate from '@/pages/spiders/create.vue'
import SpiderDetail from '@/pages/spiders/detail.vue'
import HelpView from '@/pages/spiders/help/index.vue'
import SpiderBaseView from '@/pages/spiders/index.vue'
import SpiderList from '@/pages/spiders/list.vue'
import ReportsView from '@/pages/spiders/reports/index.vue'
import RunDetail from '@/pages/spiders/results/detail.vue'
import RunList from '@/pages/spiders/results/list.vue'
import XPathSandbox from '@/pages/spiders/xpath-sandbox/index.vue'

export default {
  path: '/spiders/',
  redirect: '/spiders/list',
  name: 'Spiders',
  component: SpiderBaseView,
  children: [
    {
      path: 'list',
      name: 'SpiderList',
      component: SpiderList,
    },
    {
      path: 'create',
      name: 'SpiderCreate',
      component: SpiderCreate,
    },
    {
      path: 'bulk-create',
      name: 'SpiderBulkCreate',
      component: SpiderBulkCreate,
    },
    {
      path: ':id/edit',
      name: 'SpiderDetail',
      component: SpiderDetail,
    },
    {
      path: 'help',
      name: 'HelpView',
      component: HelpView,
    },
    {
      path: 'reports',
      name: 'ReportsView',
      component: ReportsView,
    },
    {
      path: 'runs',
      name: 'RunList',
      component: RunList,
    },
    {
      path: 'runs/:id',
      name: 'RunDetail',
      component: RunDetail,
    },
    {
      path: 'xpath-sandbox',
      name: 'XPathSandbox',
      component: XPathSandbox,
    },
  ],
}
